import { gql } from '@apollo/client';

export const paymentsGql = gql`
  query Payments($startDate: String!, $endDate: String!, $initialRow: Int!, $nextRows: Int!, $personId: Int!) {
    payments(
      startDate: $startDate
      endDate: $endDate
      initialRow: $initialRow
      nextRows: $nextRows
      personId: $personId
    ) {
      downloadDiscountValue
      resaleDiscountValue
      totalGCDiscountValue
      invoiceNumber
      paidValue
      paymentDate
      paymentDetail {
        advancePaymentTerm
        delayPaymentTerm
        invoiceNumber
        invoiceSerieDescription
        invoiceSubSerieNum
        issueDate
        noshowPenaltyAmount
        paymentDueDate
        personId
        personPaymentTerm
        receiptDate
        schedulePenaltyAmount
      }
      returnInvoiceNumber
      totalAddReturnInvoice
      totalAmount
      totalAmountAdvanceDiscount
      totalAmountReturnInvoice
      totalNoShowPenalty
      totalRows
    }
  }
`;
